import React from "react";
import { Link } from "react-router-dom";
import lax from "lax.js";
import OwlCarousel from "react-owl-carousel3";
import PlatinumSponsors from "../LaxButton/PlatinumSponsors";
// import GoldSponsors from '../LaxButton/GoldSponsors';

const options = {
  loop: false,
  nav: false,
  dots: false,
  autoplayHoverPause: true,
  autoplay: false,
  navText: [
    "<i class='icofont-rounded-left'></i>",
    "<i class='icofont-rounded-right'></i>",
  ],
  responsive: {
    0: {
      items: 5,
    },
    400: {
      items: 5,
    },
    576: {
      items: 5,
    },
    768: {
      items: 5,
    },
    1200: {
      items: 5,
    },
  },

};

class Partner extends React.Component {
  constructor(props) {
    super(props);
    lax.setup();

    document.addEventListener(
      "scroll",
      function (x) {
        lax.update(window.scrollY);
      },
      false
    );

    lax.update(window.scrollY);
  }

  render() {
    return (
      <div id="Brands">
        <section id="sponsors" className="partner-area ptb-120" >
          <div className="container">
            {/* <div className="section-title">
                        <span>Check Who Makes This Event Possible!</span>
                        <h2>Our Event <b>Sponsors</b></h2>

                        <Link to=" " className="btn btn-primary">Become Link Sponsor</Link>

                        <div className="bar"></div>
                    </div> */}

            <div className="row">
              <div className="col-lg-12">
                <div className="partner-title platinum-sponsor" >
                  <PlatinumSponsors />
                </div>
              </div>
              {/* <OwlCarousel
                className="platinum-partner-slides owl-carousel owl-theme" style={{display: "flex", flexWrap: "wrap"}}
                {...options}
              > */}
              <div className="row justify-content-center">
                <div className="col-lg-2 col-md-3"  >
                  <div className="partner-item" >
                    <div className="inner-item" >
                      <img
                        src={require("../../assets/images/Rotary.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                      <img
                        src={require("../../assets/images/Rotary.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                          
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-3">
                  <div className="partner-item">
                    <div className="inner-item">
                      <img
                        src={require("../../assets/images/shrameco.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "cover",
                        }}
                      />
                      <img
                        src={require("../../assets/images/shrameco.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-3">
                  <div className="partner-item">
                    <div className="inner-item">
                      <img
                        src={require("../../assets/images/st vincent logo.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                      <img
                        src={require("../../assets/images/st vincent logo.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-5">
                  <div className="partner-item">
                    <div className="inner-item">
                      <img
                        src={require("../../assets/images/wilfred.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                      <img
                        src={require("../../assets/images/wilfred.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-5" style={{paddingTop: "10px"}}>
                  <div className="partner-item">
                    <div className="inner-item">
                      <img
                        src={require("../../assets/images/Amity_University_logo.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                      <img
                        src={require("../../assets/images/Amity_University_logo.png")}
                        alt="Partner Logo"
                        style={{
                          width: "259px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                </div>
            </div>
              {/* </OwlCarousel> */}

              {/* <div className="col-lg-12">
                            <div className="border"></div>
                        </div> */}

              {/* <div className="col-lg-12">
                            <div className="partner-title gold-sponsor">
                                <GoldSponsors />
                            </div>
                        </div> */}

              {/* <OwlCarousel 
                            className="gold-partner-slides owl-carousel owl-theme"
                            {...options}
                        >
                            <div className="col-lg-12 col-md-12">
                                <div className="partner-item">
                                    <div className="inner-item">
                                        <img src={require("../../assets/images/gold-partner1.png")} alt="Partner Logo" />
                                        <img src={require("../../assets/images/gold-partner1.png")} alt="Partner Logo" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 col-md-12">
                                <div className="partner-item">
                                    <div className="inner-item">
                                        <img src={require("../../assets/images/gold-partner2.png")} alt="Partner Logo" />
                                        <img src={require("../../assets/images/gold-partner2.png")} alt="Partner Logo" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 col-md-12">
                                <div className="partner-item">
                                    <div className="inner-item">
                                        <img src={require("../../assets/images/gold-partner3.png")} alt="Partner Logo" />
                                        <img src={require("../../assets/images/gold-partner3.png")} alt="Partner Logo" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 col-md-12">
                                <div className="partner-item">
                                    <div className="inner-item">
                                        <img src={require("../../assets/images/gold-partner4.png")} alt="Partner Logo" />
                                        <img src={require("../../assets/images/gold-partner4.png")} alt="Partner Logo" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 col-md-12">
                                <div className="partner-item">
                                    <div className="inner-item">
                                        <img src={require("../../assets/images/gold-partner5.png")} alt="Partner Logo" />
                                        <img src={require("../../assets/images/gold-partner5.png")} alt="Partner Logo" />
                                    </div>
                                </div>
                            </div>
                        </OwlCarousel> */}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Partner;
